// Ключі до слайда — збираються автоматично з даних уроку (той самий JSON, що й для кнопки Answers).
// Повертає масив рядків { n?, text } або [] (на слайді немає перевірюваних відповідей).

const first = (alts = "") => String(alts).split("|")[0].trim();
const clean = (text = "") => String(text).replace(/\*\*/g, "").replace(/\s+/g, " ").trim();

// ((a|*b|c)) → b ; кілька виборів у рядку → «b / e»
const chosen = (text = "") =>
  [...String(text).matchAll(/\(\(([^)]*)\)\)/g)]
    .map((m) => (m[1].split("|").find((o) => o.startsWith("*")) || "").replace(/^\*/, "").trim())
    .filter(Boolean);

// [[a|b]] → a ; {{example}} — приклад, не ключ
const gaps = (text = "") => [...String(text).matchAll(/\[\[([^\]]*)\]\]/g)].map((m) => first(m[1]));

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

export function slideKey(slide) {
  const d = slide?.data || {};
  const out = [];
  const add = (text, n) => text && out.push({ n, text: clean(text) });
  switch (slide?.type) {
    case "choose":
    case "video":
    case "reading": {
      if (d.poll) return [{ text: "Відповіді учня (опитування) — правильних немає" }];
      let n = 0;
      (d.lines || []).forEach((line) => {
        const picks = chosen(line.text);
        if (picks.length) add(picks.join(" / "), ++n);
      });
      break;
    }
    case "fill_gaps": {
      let n = 0;
      (d.lines || []).forEach((line) => {
        const g = gaps(line.text);
        if (g.length) add(g.join(" / "), ++n);
      });
      break;
    }
    case "match_images":
      (d.items || []).forEach((item, i) => add(`${LETTERS[i]} — ${item.answer}`));
      break;
    case "match_pairs":
      (d.pairs || []).forEach((p, i) => add(`${p.left} → ${p.right}`, i + 1));
      break;
    case "order":
      (d.items || []).forEach((item, i) => add(item, i + 1));
      break;
    case "quiz":
      (d.questions || []).forEach((q, i) => add(`${q.q} → ${q.options?.[q.answer] ?? ""}`, i + 1));
      break;
    case "buckets":
      (d.buckets || []).forEach((b) => {
        const items = (d.items || []).filter((it) => it.bucket === b).map((it) => it.text);
        if (items.length) add(`${b}: ${items.join(", ")}`);
      });
      break;
    case "find_mistake":
      (d.lines || []).forEach((l, i) => add(`${l.wrong} → ${l.fix}`, i + 1));
      break;
    case "unscramble":
      (d.items || []).forEach((it, i) => add(first(it.answer), i + 1));
      break;
    case "listen_write": {
      const start = d.startAt || 1;
      (d.answers || []).forEach((a, i) => add(first(a), start + i));
      break;
    }
    case "write":
      (d.lines || []).forEach((l, i) => l.answer && add(first(l.answer), i + 1));
      break;
    default:
      break;
  }
  return out;
}
